module.exports = __webpack_public_path__ + "static/media/receivable_wellcome.45642637.png";